import "./App.css";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "./components/site/Header";
import { Footer } from "./components/site/Footer";
import { ChatWidget } from "./components/site/ChatWidget";
import { FloatingCall } from "./components/site/FloatingCall";
import Home from "./pages/Home";
import ServiceArea from "./pages/ServiceArea";
import Dashboard from "./pages/Dashboard";

function SiteLayout() {
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <FloatingCall />
      <ChatWidget />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#F6F5F0]">
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/service-area/:slug" element={<ServiceArea />} />
          </Route>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
